import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h5 font-weight-bold text-white text-center" }

import { MINAS_CONFIG, changeURL } from '@/constants/apis';
import { VISIBLE_PAGES } from '@/constants/labels';
import router from '@/router';
import { useStore } from 'vuex';
import { useTheme } from 'vuetify';


export default /*@__PURE__*/_defineComponent({
  __name: 'PrincipalPageView',
  setup(__props) {

const store = useStore();
const theme = useTheme();

const projects = [
  { key: 'CANANEA', title: 'SmartLink Cananea', icon: 'mdi-domain' },
  { key: 'COLLAHUASI', title: 'SmartLink Collahuasi', icon: 'mdi-factory' },
  { key: 'NACOZARI', title: 'SmartLink Nacozari', icon: 'mdi-transmission-tower' },
  { key: 'TEPEACA', title: 'SmartLink Tepeaca', icon: 'mdi-truck-cargo-container' },
];

const seleccionarProyecto = (keyMina: string) => {
  const minaData = MINAS_CONFIG[keyMina as keyof typeof MINAS_CONFIG];

  if (minaData) {
    changeURL(minaData.index);
    store.commit('setProjectName', minaData.name);
    store.commit('setProjectLAT', minaData.lat);
    store.commit('setProjectLNG', minaData.lng);
    store.commit('setProjectZOOM', minaData.zoom);

    store.commit('setAppBarPage', 'smartlinkPage');

    minaData.index === 3 ? router.push(`/smartlink/cemex/${VISIBLE_PAGES.tepeaca.dashboard}`) : router.push(`/smartlink/${VISIBLE_PAGES.dashboard}`)
    ;
  }
};

const cerrarSesionDesarrollador = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("rol");
  store.commit("setUserSesion", null);
  // store.commit("setUserRol", null);

  store.commit('setAppBarPage', 'loginPage');
  router.push('/login');

  theme.change("darkCustom");
};

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "principal-container fill-height pa-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        align: "center",
        justify: "center",
        class: "ma-0 w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "text-center mb-6"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("h1", { class: "text-h3 font-weight-bold text-white mb-2" }, " Seleccione el Proyecto ", -1),
              _createElementVNode("p", { class: "text-subtitle-1 text-grey-lighten-1" }, " Elija una sede para cargar la configuración correspondiente o cierre sesión ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "10",
            lg: "10",
            xl: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                justify: "center",
                align: "stretch"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projects, (project, index) => {
                    return _createVNode(_component_v_col, {
                      key: index,
                      cols: "12",
                      sm: "6",
                      md: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "project-card d-flex flex-column justify-center align-center pa-6 rounded-xl h-100",
                          elevation: "10",
                          onClick: ($event: any) => (seleccionarProyecto(project.key))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "50",
                              color: "white",
                              class: "mb-4"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(project.icon), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("h2", _hoisted_1, _toDisplayString(project.title), 1),
                            _createVNode(_component_v_btn, {
                              class: "mt-6 font-weight-bold text-none rounded-lg",
                              color: "white",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode(" Ingresar ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  }), 64)),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "project-card logout-card d-flex flex-column justify-center align-center pa-6 rounded-xl h-100",
                        elevation: "10",
                        onClick: cerrarSesionDesarrollador
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "50",
                            color: "error",
                            class: "mb-4"
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode(" mdi-logout ", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-h5 font-weight-bold text-white text-center" }, " Cerrar Sesión ", -1)),
                          _createVNode(_component_v_btn, {
                            class: "mt-6 font-weight-bold text-none rounded-lg",
                            color: "error",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode(" Salir ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})